import React, { useState, useEffect } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiX } = FiIcons;

const PropertyModal = ({ isOpen, onClose, onSave, initialData, customFieldDefs }) => {
  const defaults = {
    name: '', address: '', status: 'Vacant', rentRate: '',
    tenantName: '', tenantEmail: '', leaseStart: '', leaseEnd: '',
    customFields: {}
  };
  const [formData, setFormData] = useState(defaults);

  const propCustomFields = (customFieldDefs || []).filter(f => f.appliesTo === 'property' || f.appliesTo === 'both');

  useEffect(() => {
    if (initialData) setFormData({ ...defaults, ...initialData, customFields: initialData.customFields || {} });
    else setFormData(defaults);
  }, [initialData, isOpen]);

  if (!isOpen) return null;

  const customFieldValues = formData.customFields || {};
  const setCustomField = (fieldName, value) => {
    setFormData(prev => ({ ...prev, customFields: { ...prev.customFields, [fieldName]: value } }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-2xl max-h-[90vh] overflow-hidden flex flex-col">
        <div className="flex justify-between items-center px-6 py-4 border-b border-gray-100 shrink-0">
          <h2 className="text-lg font-bold text-gray-900">{initialData ? 'Edit Property' : 'Add Property'}</h2>
          <button onClick={onClose} className="p-1.5 text-gray-400 hover:text-gray-600 rounded-lg hover:bg-gray-100"><SafeIcon icon={FiX} size={18} /></button>
        </div>
        <form onSubmit={handleSubmit} className="flex-1 overflow-y-auto p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="col-span-2">
              <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">Property Name *</label>
              <input required value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})}
                className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20 outline-none" />
            </div>
            <div className="col-span-2">
              <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">Address *</label>
              <input required value={formData.address} onChange={e => setFormData({...formData, address: e.target.value})}
                className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20 outline-none" />
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">Status</label>
              <select value={formData.status} onChange={e => setFormData({...formData, status: e.target.value})}
                className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20 outline-none">
                <option value="Vacant">Vacant</option>
                <option value="Occupied">Occupied</option>
                <option value="Maintenance">Maintenance</option>
              </select>
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">Rent Rate ($)</label>
              <input type="number" value={formData.rentRate} onChange={e => setFormData({...formData, rentRate: e.target.value})}
                className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20 outline-none" />
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">Lock Code</label>
              <input value={formData.lockCode || ''} onChange={e => setFormData({...formData, lockCode: e.target.value})}
                className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20 outline-none" placeholder="e.g. 1234#" />
            </div>

            {propCustomFields.length > 0 && (
              <>
                <div className="col-span-2 pt-3 mt-2 border-t border-gray-100">
                  <p className="text-xs font-semibold text-indigo-600 uppercase">Custom Fields</p>
                </div>
                {propCustomFields.map(cf => (
                  <div key={cf.name}>
                    <label className="block text-xs font-semibold text-gray-500 uppercase mb-1">{cf.name}</label>
                    <input value={customFieldValues[cf.name] || ''} onChange={e => setCustomField(cf.name, e.target.value)}
                      className="w-full px-3 py-2.5 rounded-lg border border-gray-200 text-sm focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20 outline-none" placeholder={cf.name} />
                  </div>
                ))}
              </>
            )}
          </div>
          <div className="mt-6 flex justify-end gap-3">
            <button type="button" onClick={onClose} className="px-4 py-2.5 text-sm font-medium text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors">Cancel</button>
            <button type="submit" className="px-5 py-2.5 bg-indigo-600 text-white text-sm font-semibold rounded-lg hover:bg-indigo-700 transition-colors">Save Property</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PropertyModal;
